export default "/images/d2919a85810c71fed9a566ec82016697.avif";